import { render, staticRenderFns } from "./EarlyWarningSettings.vue?vue&type=template&id=8028c136&scoped=true"
import script from "./EarlyWarningSettings.vue?vue&type=script&lang=ts"
export * from "./EarlyWarningSettings.vue?vue&type=script&lang=ts"
import style0 from "./EarlyWarningSettings.vue?vue&type=style&index=0&id=8028c136&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8028c136",
  null
  
)

export default component.exports